import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

import FormControlFeedback from "../formControlFeedback/formControlFeedback";

import "./checkbox.scss";

const Checkbox = ({
  id,
  invalidFeedback = null,
  isInvalid = false,
  label,
  name,
  required = false,
  small = false,
  value = false,
  onChange = () => {},
  onBlur = () => {},
  checked = false,
}) => (
  <Form.Check
    type="checkbox"
    id={id}
    className={classNames("checkbox", { "checkbox--small": small, required })}
  >
    <Form.Check.Input
      checked={checked}
      type="checkbox"
      name={name}
      isInvalid={isInvalid}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
    />
    <Form.Check.Label>
      {label}
    </Form.Check.Label>
    {isInvalid && invalidFeedback && (
      <FormControlFeedback>{invalidFeedback}</FormControlFeedback>
    )}
  </Form.Check>
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  id: PropTypes.string.isRequired,
  invalidFeedback: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  isInvalid: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]).isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  small: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Checkbox;
